import { useNavigate } from 'react-router-dom'
import { getFeedRoute, getRoute } from 'src/libs/layouts'
import TrackPartners from '../project/projectData/TrackPartners'
import { syncAction } from '../../data/actions'
import { SET_FILTERS_ACTIONS } from '../../data/actionTypes'

const TrackLabel = (props: any): JSX.Element | null => { 
    const navigate = useNavigate()
    const routeSingle = getFeedRoute("PEFestProject") 
    const _url = routeSingle || props.track?.id
        ? 
        `/${ getRoute(routeSingle)}?tack=${ props.track?.id }` 
        : 
        "/"
    const onClick = () => {
        const selectTracks = [ props.track.id ] 
        syncAction(
            SET_FILTERS_ACTIONS, 
            { 
                filters:{ 
                    tracks: selectTracks
                } 
            } 
        )
        navigate( _url )
    }
    return props.track
        ?
        <div className={props.className ? `${props.className} flex-wrap` : `fest-card-track-label flex-wrap`}  data-testid="track-label-cont">
            {
                props.track?.thumbnail 
                    ? 
                    <img src={props.track?.thumbnail} alt="" className='track-miniature'/> 
                    :
                    null
            }
            <div data-to={_url} className='track-label-label text-nowrap flex-grow-100 mr-3 pointer hover' onClick={onClick}>{ props.track?.title }</div>
            { props.isPartners && <TrackPartners project={props.project} track={props.track} />}
        </div>
        :
        null
} 

export default TrackLabel